export default async (context) => {
	await context.store.dispatch("features/init");

	const toggles = context?.store?.state?.features?.toggles || [];
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ tbl_toggles: toggles.join(",") });
};
